import { Admission } from '@domain/admission';
import { AdmissionResponse } from '@hooks/admissions/use-get-admissions';
import { formatCurrency } from '@utils/price-formatter/price-formatter';
import { TFunction } from 'i18next';

export const findOfferById = (list: AdmissionResponse, offerId: string): Admission | undefined => {
  return Object.values(list).reduce((foundAdmission: Admission | undefined, currentList: Admission[]) => {
    return foundAdmission ?? currentList.find((admission) => admission.id === offerId);
  }, undefined);
};
export const formatLabel = ({ offer, name, t }: { offer: Admission; name: string; t: TFunction }) => {
  const {
    price: { amount, currency },
    settings: { italyRegulation },
    quantity,
    soldItems,
    salesStatus: { isSalesClosed, isSoldOut },
  } = offer;

  const ddp = italyRegulation?.dirittoPrevendita;
  const formattedPrice = formatCurrency({
    number: amount,
    currency,
  });
  const ticketsLeftLabel = quantity
    ? `- ${t('offers:admissionQuantityLeft', { ticketsLeft: quantity - soldItems })}`
    : '';
  const salesClosesLabel = isSalesClosed ? `- ${t('common:admissionStatusSalesEnded')}` : '';
  const soldOutLabel = isSoldOut ? `- ${t('common:admissionStatusSoldOut')}` : '';
  const ticketLabel = `${name} ${ticketsLeftLabel} ${soldOutLabel} ${salesClosesLabel}`;

  if (ddp) {
    const formattedDDP = formatCurrency({ number: ddp, currency });
    return `${formattedPrice} + ${formattedDDP} DDP - ${ticketLabel}`;
  }

  return `${formattedPrice} - ${ticketLabel}`;
};
